import Mutations from './data/mutations'
import { format } from 'date-fns'
export default {
  namespaced: true,
  state: {
    drawer: false,
    billingPeriod: format(new Date(), 'YYYY-MM'),
    billingStatus: null,
    projectId: null,
    siteId: null,
    selectedUserId: null,
    showCreated: false,
    showInactive: false,
    dateRangeStart: null,
    dateRangeEnd: null,
    dateRangeToggle: false,
    pdfInvoiceDialog: false,
    pdfDialog: false,
    showClosed: false,
    useSingleDate: false,
    tippingDefaultHeaders: [
      'id',
      'tippingDocketHeader.externalRef',
      'tippingDocketHeader.date',
      'status',
      'tippingDocketHeader.tip.name',
      'tippingDocketHeader.vehicle.contractor.name',
      'tippingDocketHeader.vehicle.name',
      'tippingDocketHeader.isDay',
      'qty',
      'costPrice',
      'costTotal',
      'createdAt',
      'updatedBy.name'
    ],
    batchAllocationLineDefaultHeaders: [
      'startTime',
      'tip.name',
      'spoil.name',
      'vehicle.contractor.name',
      'vehicle.name',
      'driver.name',
      'allocationId'
    ],
    batchAllocationDefaultHeaders: [
      'date',
      'site.project.name',
      'site.name',
      'spoil.name',
      'lineCount'
    ],
    allocationDefaultHeaders: [
      'date',
      // 'details',
      'site.project.name',
      'site.name',
      'tip.name',
      'spoil.name',
      'vehicleType.name',
      'vehicle.name'
    ],
    tripDefaultHeaders: [
      'docket.date',
      'docket.externalRef',
      'docket.site.name',
      'spoil.name',
      'hours',
      'siteWeight',
      'costTotal',
      'sellTotal'
    ],
    rateDefaultHeaders: [
      'active',
      'project.name',
      'site.name',
      'spoil.name',
      'tip.name',
      'vehicleType.name',
      'costPrice',
      'sellPrice'
    ],
    billDefaultHeaders: [
      'id',
      'date',
      'externalRef',
      'project.name',
      'total',
      'siteWeightTotal',
      'trips',
      'status',
      'user.email'
    ],
    rctiDefaultHeaders: [
      'id',
      'date',
      'externalRef',
      'project.name',
      'contractor.name',
      'total',
      'siteWeightTotal',
      'trips',
      'status',
      'user.email'
    ],
    complianceDefaultHeaders: [
      'id',
      'name',
      'belongsTo',
      'typeDisp',
      'modelDisp',
      'contactEmail',
      'dateDisp',
      'notes'
    ],
    approvedBillLineDefaultHeaders: [
      'id',
      'qty',
      'rate',
      'amount',
      'customerClaimRef',
      'notes',
      'tripId',
      'billLineId',
      'createdBy.name',
      'createdAt',
      'updatedAt'
    ]
  },
  mutations: Mutations,
  actions: {},
  getters: {}
}
